import ABI from './abi.json';
import { ChainId } from '../../constants';

export const Config = {
    [ChainId.metisMainnet]: {
        address: '0x4200000000000000000000000000000000000010',
        abi: ABI,
    },
    [ChainId.metisTestnet]: {
        address: '0x4200000000000000000000000000000000000010',
        abi: ABI,
    },
};
